import { render, staticRenderFns } from "./MaterialityBadge.vue?vue&type=template&id=1632b71c"
import script from "./MaterialityBadge.vue?vue&type=script&lang=js"
export * from "./MaterialityBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports